import styled from 'styled-components';
import { Box } from '@mui/material';

export const ContextMenuStyled = styled(Box)`
  display: grid;
  grid-template-rows: 1fr;
`;

export const ContextMenuItemStyled = styled(Box)`
  display: flex;
  padding: 0px 25px;
  margin-bottom: 10px;
  font-family: SourceSansPro;
  font-weight: 400;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  &:first-child {
    padding-top: 15px;
  }
  &:last-child {
    padding-bottom: 15px;
    margin-bottom: 0;
  }

  &:not(:last-child) {
    &:after {
      content: '';
      height: 15px;
    }
  }
`;